<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        created() {
            document.title = this.$t(`${this.$route.meta.title}.title_page`);
            const loginUser = JSON.parse(localStorage.getItem('user'));
            if (!loginUser.admin) {
                return  this.$router.push({ name: 'dashboard' });
            }
        }
    }
</script>
<style scoped>
    ul li {
        padding: 5px 0;
        list-style-type: none;
    }
</style>
